import { connect } from 'react-redux';
import { compose } from 'ramda';
import { withRouter } from 'react-router-dom';
import OSSAgreement from './oss-agreement';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import { OSSAgreementActions, getOSSAgreementInfoSelector } from './oss-agreement.reducer';

const mapDispatchToProps = (dispatch) => ({
  getOSSAgreementValidation: () => dispatch(OSSAgreementActions.initialOSSAgreementRequest()),
});

export default compose(
  withLDConsumer(),
  withRouter,
  connect(getOSSAgreementInfoSelector, mapDispatchToProps),
)(OSSAgreement);
